// extracted by mini-css-extract-plugin
export default {"slider":"Portfolio_slider__UCgGQ","wraper":"Portfolio_wraper__VVmbN"};